/**
 * idleTimer.ts
 * Signs out the user after 10 minutes of no interaction.
 * Resets on any mouse, touch, keyboard, or scroll event.
 * Call startIdleTimer() after login, stopIdleTimer() on logout.
 */

const IDLE_MS = 60 * 60 * 1000 // 60 minutes (desktop only — mobile keeps its own shorter timeout)

let _timer: ReturnType<typeof setTimeout> | null = null
let _onTimeout: (() => void) | null = null

const EVENTS = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll', 'click', 'wheel']

function reset() {
  if (_timer) clearTimeout(_timer)
  _timer = setTimeout(() => {
    if (_onTimeout) _onTimeout()
  }, IDLE_MS)
}

export function startIdleTimer(onTimeout: () => void) {
  _onTimeout = onTimeout
  EVENTS.forEach(e => window.addEventListener(e, reset, { passive: true }))
  reset()
}

export function stopIdleTimer() {
  if (_timer) clearTimeout(_timer)
  _timer = null
  _onTimeout = null
  EVENTS.forEach(e => window.removeEventListener(e, reset))
}
